// src/hr/kit/Avatar.js -- initials on a stable gradient (avatarColor of the person's id).
import React from 'react';
import { avatarColor, initials } from '../format';
import { cx } from './util';

// size: 'sm' | 'md' | 'lg'. Decorative by default (the name is usually printed next to it);
// pass `labelled` where the avatar stands alone, e.g. in a stack of who's out.
export function Avatar({ name, id, size = 'md', labelled = false, className }) {
  const a11y = labelled ? { role: 'img', 'aria-label': name, title: name } : { 'aria-hidden': 'true' };
  return (
    <span className={cx('hrp-av', `hrp-av--${size}`, `hrp-av--${avatarColor(id == null ? name : id)}`, className)} {...a11y}>
      {initials(name)}
    </span>
  );
}

export default Avatar;
